export default __webpack_public_path__ + "assets/523e812ed82af5cf8f07f2255c80c402.svg";